import React from 'react';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import IntlProviderRedux from 'containers/IntlProviderRedux';
import './index.css';
import configStore from 'store/configStore';

render(
  <Provider store={configStore}>
    <IntlProviderRedux>
      <App />
    </IntlProviderRedux>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
